export type ReceivedProps = Record<string, any>;

const useDashBoard = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useDashBoard>;

export default useDashBoard;
